/* eslint-disable dot-notation */
/* eslint-disable react/prop-types */
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import isNaN from 'lodash/isNaN'

import { ppsSelector } from '../../../selectors'

import GrossProfits from '../../../components/project-profit-sheet/GrossProfits'

import { selectMode } from '../model'

const fallbackNaN = (number) => (isNaN(number) ? '0.00' : number)

/**
 * @param {object} props
 * @param {object} props.profitData
 * @param {string} props.display
 */
function GrossProfitsContainer({ profitData, display }) {
  const mode = selectMode(display)
  const data = {
    overallInitial: fallbackNaN(profitData[`$${mode}_gross_profits_overall_ratio_initial_plan`]),
    overallForecastActual: fallbackNaN(profitData[`$${mode}_gross_profits_overall_ratio_forecast`]),
    overallFormPreviousMonth: fallbackNaN(profitData[`$${mode}_gross_profits_overall_ratio_forecast_from_previous`]),
    serviceOrigin: fallbackNaN(profitData[`$${mode}_gross_profits_ratio_origin_plan`]),
    serviceOriginValue: fallbackNaN(profitData[`$${mode}_gross_profits_origin_plan`]),
    serviceInitial: fallbackNaN(profitData[`$${mode}_gross_profits_ratio_initial_plan`]),
    serviceInitialValue: fallbackNaN(profitData[`$${mode}_gross_profits_initial_plan`]),
    serviceForecastActual: fallbackNaN(profitData[`$${mode}_gross_profits_ratio_forecast`]),
    serviceForecastActualValue: fallbackNaN(profitData[`$${mode}_gross_profits_forecast`]),
    serviceFormPreviousMonth: fallbackNaN(profitData[`$${mode}_gross_profits_ratio_forecast_from_previous`]),
  }

  return <GrossProfits { ...data } />
}

const mapStateToProps = createStructuredSelector({
  profitData: ppsSelector.profitData,
  display: ppsSelector.display,
})

export default connect(mapStateToProps)(GrossProfitsContainer)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/GrossProfitsContainer.js